import axios from "axios";


export const parseCallback = () =>{

};

export const signup = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/users/signup/buyer`, payload);
    // console.log("signup result:", result);
    return result.data;
};

export const signin = async (credentials) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/users/signin`, credentials);
    // console.log("result", result);
    return result.data;
    // console.log("cred", credentials);
    // if (credentials.username !== credentials.password) {
    //     return {
    //         "status": "error",
    //         "message": "Invalid username or password"
    //     }
    // } else {
    //     return {
    //         "status": "success",
    //         "user": {
    //             "username" : "dd",
    //
    //         },
    //         "tokens" : {
    //             "access" : "token-1234567890",
    //             "refresh" : "refresh-1234567890",
    //             "chat" : "2ba500ccfa00c6c7447ef651cd8b662ecd5e876b"
    //         }
    //     }
    // }
};

export const validateAccessToken = (token) => {
    if (false) {
        return {
            "status": "error",
            "message": "Invalid token"
        }
    } else {
        return {
            "status": "success"
        }
    }
}
